export default "__VITE_ASSET__DhkFhh0s__"